var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTiktokFillCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1001,
    cy: 16.5,
    r: 16.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0043 7.01519C18.0086 7 19.0072 7.009 20.0045 7C20.065 8.14812 20.4874 9.31762 21.3472 10.1294C22.2053 10.9613 23.4191 11.3422 24.6001 11.471V14.4912C23.4934 14.4558 22.3815 14.2308 21.3772 13.765C20.9398 13.5715 20.5323 13.3223 20.1335 13.0674C20.1283 15.2591 20.1427 17.4479 20.1191 19.6305C20.0592 20.679 19.7053 21.7225 19.0814 22.5866C18.0777 24.025 16.3356 24.9627 14.5463 24.992C13.4488 25.0533 12.3524 24.7608 11.4172 24.2219C9.86728 23.3286 8.77667 21.6933 8.61782 19.9382C8.59782 19.5665 8.59474 19.1941 8.60862 18.8221C8.74674 17.395 9.46902 16.0297 10.5901 15.101C11.8609 14.0192 13.641 13.504 15.3077 13.8089C15.3232 14.9199 15.2778 16.0297 15.2778 17.1407C14.5164 16.9 13.6266 16.9675 12.9613 17.4192C12.4745 17.7326 12.1067 18.1937 11.9144 18.7316C11.7556 19.1118 11.801 19.5343 11.8103 19.9382C11.9927 21.169 13.2036 22.2035 14.4962 22.0916C15.3532 22.0826 16.1744 21.5965 16.621 20.8849C16.7655 20.6357 16.9272 20.3809 16.9359 20.0878C17.0113 18.7462 16.9813 17.4102 16.9905 16.0685C16.9969 13.0449 16.9813 10.0298 17.0049 7.01575L17.0043 7.01519Z",
    fill: "#223A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTiktokFillCircle);
export default __webpack_public_path__ + "static/media/ic-tiktok-fill-circle.e5e4a7ce1ef6c362ae1684ee41e3424a.svg";
export { ForwardRef as ReactComponent };